module.exports = function () {
  return new Worker("/" + "./assets/4777192888bb1b8a280d.worker.js");
};